/**
 * return the height given mdRows
 */
export const computeHeightInRows = ({
  mdRows
}) => mdRows ? parseInt(mdRows, 10) : 1;
export const computeHeightInPixels = format => `${32 * computeHeightInRows(format)}px`;